
/* Pet Paradise — Quick Add JS */
(function(){
  document.addEventListener('click', function(ev){
    var t = ev.target;
    if (!t) return;
    var qa = t.closest('[data-pp-quick-add]');
    if (!qa) return;

    // + and - buttons
    if (t.matches('[data-pp-qty-inc], [data-pp-qty-dec]')) {
      ev.preventDefault(); ev.stopPropagation();
      var val = qa.querySelector('[data-pp-qty-val]');
      if (!val) return;
      var n = parseInt(val.textContent, 10) || 1;
      n = t.matches('[data-pp-qty-inc]') ? n + 1 : Math.max(1, n - 1);
      val.textContent = n;
      return;
    }

    // Add to cart
    var addBtn = t.closest('[data-pp-add-btn]');
    if (!addBtn || addBtn.disabled || addBtn.classList.contains('pp-add-btn--sold-out')) return;
    ev.preventDefault(); ev.stopPropagation();

    var variantId = qa.getAttribute('data-variant-id');
    var qtyEl = qa.querySelector('[data-pp-qty-val]');
    var qty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;

    addBtn.classList.remove('is-success');
    addBtn.classList.add('is-loading');
    addBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    }).then(function(r){
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function(){
      addBtn.classList.remove('is-loading');
      addBtn.classList.add('is-success');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return fetch('/cart.js').then(function(r){ return r.json(); });
    }).then(function(cart){
      if (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count, .cart__count, .js-cart-count').forEach(function(el){
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
      }
      setTimeout(function(){
        addBtn.classList.remove('is-success');
        addBtn.disabled = false;
      }, 1400);
    }).catch(function(err){
      console.warn('[pp-quick-add]', err);
      addBtn.classList.remove('is-loading');
      addBtn.disabled = false;
      alert('לא הצלחנו להוסיף לסל, נסה שוב');
    });
  }, false);
})();
